module.exports = __webpack_public_path__ + "media/images/upload-image-a81aea27e02cec5b8e4b42c79ac229c7.png";